'use client';

import React from 'react';
import type { Form } from '../../payload-types';
import ContactFormClient from './contact-form-client';
import CalendlyEmbed from './calendly-embed';

const IntegrationForm: React.FC<{
  form: Form;
  successText?: string | null;
}> = ({ form, successText }) => {
  switch (form.integrationMode) {
    case 'calendly':
      return <CalendlyEmbed form={form} />;

    case 'activecampaign':
    case 'internal':
    default:
      // Both AC and internal use the same form fields + submission hook.
      // The server action branches based on integrationMode.
      return <ContactFormClient form={form} successText={successText} />;
  }
};

export default IntegrationForm;
